<template>
  <b-overlay :show="Esperar">
    <b-modal v-model="verAddRegion" @show="resetModal">
      <template #modal-header> Agregar Region </template>

      <b-input-group prepend="Nombre">
        <b-form-input autofocus v-model="region.Nombre" required></b-form-input>
      </b-input-group>

      <b-input-group prepend="Codigo" class="my-2">
        <b-form-input v-model="region.Codigo"></b-form-input>
      </b-input-group>

      <template #modal-footer>
        <b-button variant="primary" @click="AgregaRegion">Guardar</b-button>
      </template>
    </b-modal>

    <b-table responsive="sm" small striped bordered :items="Paises" :fields="['Nombre', 'Precio', 'Codigo']">
      <template #cell(Precio)="row">
        <b-input type="number" size="sm" @blur="CambioPrecio(row.item)" v-model="row.item.Precio"></b-input>
      </template>
      <template #cell(Codigo)="row">
        <b-row>
          <b-col>{{ row.item.Codigo }} </b-col>
          <b-col class="text-center"> <b-button @click="row.toggleDetails" size="sm" pill variant="success">...</b-button> </b-col>
        </b-row>
      </template>
      <template #row-details="row">
        <b-table-lite small striped table-variant="primary" :items="row.item.Regiones" :fields="['Codigo', 'Nombre']"></b-table-lite>

        <b-button pill variant="primary" size="sm" @click="verModal(row.item.id, row.item)">+ Region</b-button>
      </template>
    </b-table>

    <b-alert variant="success" :show="verAlert" @dismissed="verAlert = 0"> <b-icon-info-square-fill /> El precio fue actualizado!</b-alert>
  </b-overlay>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";

if (!firebase.apps.length) firebase.initializeApp({ projectId: "diazvelizexpress" });
else firebase.app();

const db = firebase.firestore();
export default {
  beforeCreate() {
    let aplica = this.$session.get("EsAdmin");
    if (!aplica) this.$router.push("/courier/home");
  },
  data() {
    return {
      Esperar:true,
      verAlert: 0,
      Paises: [],
      selPais: {},
      selCode: null,
      region: { Nombre: "" },
      verAddRegion: false,
    };
  },
  firestore: {
    Paises: db.collection("Pais"),
  },
  mounted(){
    this.Esperar=false;
  },
  methods: {
    AgregaRegion(){
      this.verAddRegion=false;
      this.Esperar=true;
      this.selPais.Regiones.push({Nombre:this.region.Nombre.toUpperCase(), Codigo:this.region.Codigo.toUpperCase()});

      let upd={...this.selPais};

      db.collection("Pais").doc(this.selPais.id).update(upd).then(()=>{

        this.Esperar=false;
        this.$bvModal.msgBoxConfirm("El envio fue actualizado!");

      });


      
    },
    verModal(id, pais) {
      delete pais._showDetails;

      this.selPais=pais;
      this.selCode=id;
      
      this.verAddRegion = true;
    },
       CambioPrecio(v) {
      let p = parseFloat(v.Precio);

      if (p > 0) {
        db.collection("Pais")
          .doc(v.id)
          .update({ Precio: p })
          .then(() => {
            this.verAlert = 2;
          });
      }
    },

    resetModal() {
      this.region.Nombre = "";
      this.region.Codigo = "";
      (this.nameState = null), (this.codState = null);
    },
  },
};
</script>
